import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import Link from '../Link';
import logoUrl from './img/new_saocal_20.png';
import logoUrlSpirotech from './img/spirotech_logo_tran.png';
import logoUrlOceanic from './img/SYR_OCEANIC_Logo.png';
import s from './Logo.css';
import {
  ILEXCONNECT_URL,
  SPIROTECH_URL,
  TEST_SPIROTECH_URL,
} from '../../constants/websites';

class Logo extends React.Component {
  render() {
    let mainLogoUrl = null;
    let alt = null;
    const { hostname } = this.props;
    switch (hostname) {
      case ILEXCONNECT_URL:
        mainLogoUrl = logoUrlOceanic;
        alt = `I-Lex ${hostname}`;
        break;
      case SPIROTECH_URL:
      case TEST_SPIROTECH_URL:
        mainLogoUrl = logoUrlSpirotech;
        alt = `Spirotech ${hostname}`;
        break;
      default:
        mainLogoUrl = logoUrl;
        alt = `Saocal ${hostname}`;
        break;
    }
    return (
      <div className={s.logo}>
        <Link className={cx(s.brand, s.Header_logo)} to="/">
          <img src={mainLogoUrl} alt={alt} />
        </Link>
      </div>
    );
  };
}

Logo.propTypes = {
  hostname: PropTypes.string,
};

Logo.defaultProps = {
  hostname: '',
};

export default withStyles(s)(Logo);


// WEBPACK FOOTER //
// ./src/components/LoginElements/Logo.js